import errorPage from "./error-page.html";
import errorNav from "./error-nav.html";

export const showErrorNav = (mf: string) => {
    const mainSection = document.querySelector("main");
    const layoutContainer = document.querySelector("#layout-container");

    const isNavigation = mf === "@newsenec/navigation";
    const navParent = isNavigation ? document.querySelector("nav") : document.querySelector("footer");

    if (navParent) {
        navParent.innerHTML = errorNav;
    } else if (mainSection) {
        isNavigation ? mainSection.prepend(errorNav) : mainSection.append(errorNav);
    } else {
        isNavigation ? layoutContainer?.prepend(errorNav) : layoutContainer?.append(errorNav);
    }
};

export const showErrorPage = () => {
    const mainSection = document.querySelector("main");
    const layoutContainer = document.querySelector("#layout-container");

    if (mainSection) {
        mainSection.innerHTML = errorPage;
    } else if (layoutContainer) {
        layoutContainer.innerHTML = errorPage;
    }
};

export const removeErrorPage = () => {
    const errorPage = document.querySelector("#error-page");
    if (errorPage) {
        errorPage.innerHTML = "";
        errorPage.remove();
    }
};
